import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromSigninPage from './signin-page.reducer';
import * as fromRoot from '../../reducers';
import * as fromAuth from './auth.reducer';
import { AuthApiActions } from '../actions';

export interface AuthState {
  status: fromAuth.State;
  signinPage: fromSigninPage.State;
}

export interface State extends fromRoot.State {
  auth: AuthState;
}

export const reducers: ActionReducerMap<AuthState, AuthApiActions.AuthApiActionsUnion> = {
  signinPage: fromSigninPage.reducer,
  status: fromAuth.reducer,
};

export const selectAuthState = createFeatureSelector<State, AuthState>('auth');
export const selectAuthStatusState = createSelector(selectAuthState, (state: AuthState) => state.status);
export const getUser = createSelector(selectAuthStatusState, fromAuth.getUser);
export const getLoggedIn = createSelector(selectAuthStatusState, fromAuth.isLoggedIn);
export const hasPrivilege = createSelector(selectAuthStatusState, fromAuth.hasPrivilege);
export const selectSigninPageState = createSelector(selectAuthState, (state: AuthState) => state.signinPage);
export const getSigninPageError = createSelector(selectSigninPageState, fromSigninPage.getError);
export const getSigninPagePending = createSelector(selectSigninPageState, fromSigninPage.getPending);
